import { QueryObserverResult, useQuery } from "react-query";

import { acatsAPIInstance } from "../api";

type AcatsContraBrokerType = "BANK" | "BROKER";

export interface AcatsContraBroker {
  name: string;
  number: string;
  type: AcatsContraBrokerType;
}

export interface ListAcatsContraBrokersResponse {
  brokers: AcatsContraBroker[];
}

export const listAcatsContrabrokers = async (): Promise<
  AcatsContraBroker[]
> => {
  const res = await acatsAPIInstance.get<ListAcatsContraBrokersResponse>(
    `/acats/contrabrokers`
  );

  return res.data.brokers;
};

export const useAcatsContraBrokers = (): QueryObserverResult<
  AcatsContraBroker[]
> => useQuery(["acats", "contrabrokers"], () => listAcatsContrabrokers());
